<template>
  <b-container>
    <nav-bar></nav-bar>
    <b-row v-if="authState !== 'signedin'">
      <b-col class="auth-form">
        <amplify-authenticator username-alias="email">
          <amplify-sign-in slot="sign-in" username-alias="email">
            <div slot="federated-buttons"></div>
          </amplify-sign-in>
          <amplify-sign-up
            slot="sign-up"
            username-alias="email"
            :formFields.prop="formFields"
          ></amplify-sign-up>
        </amplify-authenticator>
      </b-col>
      <b-col class="auth-form federated">
        <div class="signin">
          <h5><strong>{{ social.title }}</strong></h5>
          <div class="content">
            <b-button
              class="my-5"
              block
              size="lg"
              variant="outline-primary"
              @click="signIn('Google')"
            >
              <i class="fab fa-google"></i>
              {{ social.google }}
            </b-button>
            <b-button
              class="my-5"
              block
              size="lg"
              variant="outline-info"
              @click="signIn('Facebook')"
            >
              <i class="fab fa-facebook"></i>
              {{ social.facebook }}
            </b-button>
<!--            <b-button-->
<!--                class="my-5"-->
<!--                block-->
<!--                size="lg"-->
<!--                variant="outline-warning"-->
<!--                @click="signIn('Amazon')"-->
<!--            >-->
<!--              <i class="fab fa-amazon"></i>-->
<!--              {{ social.amazon }}-->
<!--            </b-button>-->
          </div>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import NavBar from "@/components/AuthNav.vue";
import { Auth } from "aws-amplify";
import { onAuthUIStateChange } from "@aws-amplify/ui-components";
export default {
  name: "UserAuth",
  components: {
    NavBar
  },
  created() {
    this.unsubscribeAuth = onAuthUIStateChange((authState) => {
          this.authState = authState;
          if (authState === 'signedin') {
            /** 登陆成功状态后，跳转到home页面 */
            this.$router.replace('/home')
                .then(() => this.$router.go(0))
                .catch(error => console.info(error.message));
          }
        });
  },
  beforeDestroy() {
    if (this.unsubscribeAuth) {
      this.unsubscribeAuth();
    }
  },
  data() {
    return {
      authState: undefined,
      unsubscribeAuth: undefined,
      /** 取消注册页面电话输入框 */
      formFields: [
        { type: 'email' },
        { type: 'password' }
      ],
      social: {
        title: process.env.VUE_APP_SOCIAL_TITLE,
        google: process.env.VUE_APP_SOCIAL_GOOGLE,
        facebook: process.env.VUE_APP_SOCIAL_FACEBOOK,
        amazon: process.env.VUE_APP_SOCIAL_AMAZON
      }
    };
  },
  methods: {
    /** 第三方用户登录认证 */
    signIn(provider) {
      Auth.federatedSignIn({ provider });
    }
  }
}
</script>

<style scoped>
amplify-authenticator {
  --amplify-primary-color: #007bff;
  --amplify-primary-tint: #409eff;
  --amplify-primary-shade: #0056b3;
}
.federated {
  display: flex;
  align-items: center;
}
.signin {
  box-sizing: border-box;
  /*border-radius: 10px;*/

  /*margin-top: 50px;*/
  width: 100%;
  /*width: 28.75rem;*/
  /*min-width: 20rem;*/
  height: auto;
  /*padding: 35px;*/

  /*padding-left: 15px;*/
  /*padding-right: 15px;*/

  background: #fff;
  border: 1px solid #eaeaea;
  /*box-shadow: 0 0 15px #cac6c6;*/
  box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.15);
  border-radius: 6px;
  padding: 35px 40px;
  margin-bottom: 20px;
  container-height: 100vh;
  container-display: flex;
  container-justify: center;
  container-align: center;
  /*--box-shadow: 1px 1px 4px 0 rgba(0, 0, 0, 0.15);*/
  /*--border-radius: 6px;*/
  /*--padding: 35px 40px;*/
  /*--margin-bottom: 20px;*/
  /*--container-height: 100vh;*/
  /*--container-display: flex;*/
  /*--container-justify: center;*/
  /*--container-align: center;*/
}
.content {
  margin-top: 50px;
}
</style>
